// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Chat: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<path d="M4.42,23.19v-5.46c-2.7-1.95-4.12-4.33-4.12-6.89c0-5.4,5.19-9.64,11.82-9.64c6.6,0,11.58,4.14,11.58,9.64
	c0,5.35-4.51,8.95-11.23,8.95c-0.85,0-1.78-0.14-2.62-0.29c-2.03,2.15-4.33,3.2-4.44,3.25L4.42,23.19z M12.12,2.6
	C6.28,2.6,1.7,6.21,1.7,10.83c0,2.75,2.08,4.75,3.82,5.95L5.83,17v3.94c0.86-0.52,2.13-1.4,3.25-2.66l0.26-0.3l0.39,0.08
	c0.87,0.17,1.87,0.33,2.74,0.33c5.88,0,9.83-3.04,9.83-7.55C22.3,6.14,17.92,2.6,12.12,2.6z"/>
</svg>;
};

export default React.memo(Chat);
